import { render, staticRenderFns } from "./DeteleDialog.vue?vue&type=template&id=2ff9e3b0"
import script from "./DeteleDialog.vue?vue&type=script&lang=js"
export * from "./DeteleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports